import { render } from "./BaseScene.vue?vue&type=template&id=3e4d46da"
import script from "./BaseScene.vue?vue&type=script&lang=js"
export * from "./BaseScene.vue?vue&type=script&lang=js"

import "./BaseScene.vue?vue&type=style&index=0&id=3e4d46da&lang=scss"
script.render = render

export default script